// extracted by mini-css-extract-plugin
export var layoutContainer = "_62-0";
export var layoutContainerNoRounding = "_62-6";
export var layoutContainerOpen = "_62-5";
export var layoutContainerResizing = "_62-1";
export var mainContent = "_62-2";
export var resizeDivider = "_62-3";
export var slidePanel = "_62-4";